import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AboutSection from "./AboutSection";
import ContactForm from "./ContactForm";
import AppStoreButtons from "../../components/AppStoreButtons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutAccordionPage from "../faq-aboutPage";
import { pageMetadata } from "../../config/metadata";
import { aboutFAQ } from "../../config/faqSchema";
import SEO from "../../Seo";
//new about page

const AboutPage = () => {
  const metadata = pageMetadata.aboutSeo;
  document.title = metadata.title;
  document.description = metadata.description;
  const navigate = useNavigate();

  const contactFormRef = useRef(null);
  const setFormRef = (ref) => {
    contactFormRef.current = ref;
  };

  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const curPos = window.scrollY;
      const sections = document.querySelectorAll(".feature-wrapper");
      const navLinks = document.querySelectorAll("nav a");

      sections.forEach((section) => {
        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;

        if (curPos >= top && curPos <= bottom) {
          setActiveSection(section.id);
        }
      });

      navLinks.forEach((link) => {
        const sectionId = link.getAttribute("href").slice(1);

        if (sectionId === activeSection) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);

  const scrollToSection = (id) => {
    const section = document.querySelector(id);

    window.scrollTo({
      top: section.offsetTop,
      behavior: "smooth",
    });
  };

  return (
    <>
      <SEO
        title={metadata.title}
        description={metadata.description}
        keywords={metadata.keywords}
        canonical={metadata.canonical}
        ogTitle={metadata.ogTitle}
        ogDescription={metadata.ogDescription}
        ogImage={metadata.ogImage}
        ogUrl={metadata.ogUrl}
        ogType={metadata.ogType}
        twitterCard={metadata.twitterCard}
        twitterTitle={metadata.twitterTitle}
        twitterDescription={metadata.twitterDescription}
        faqData={aboutFAQ}
      />
      <section className="banner-section home-banner-section about-banner">
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 col-lg-6 order-change left-item"
              data-aos="fade-right"
              data-aos-delay="1000"
            >
              <h1>Where Every Practice Exam Feels Fun</h1>
              <p>Discover Practido: Where Learning Becomes an Adventure! Engage, Learn, and Succeed with our innovative approach to practice and learning. Let's Make Learning Awesome Together!</p>
              <h2>Free Learning Starts Now!</h2>
              <div className="btn-inline"><AppStoreButtons variant="white" /></div>
            </div>
            <div
              className="col-md-12 col-lg-6"
              data-aos="fade-left"
              data-aos-delay="1000"
            >
              <img
                className="about-banner-img"
                src="/img/new-home/about-banner.png"
                alt="banner"
              />
            </div>
          </div>
        </div>
      </section>

      <AboutSection />

      <section className="student-vision">
        <div className="container">
          <h2>Our Vision - Making Practice Exams Fun, Not Frustrating</h2>
          <p>Our vision is bold but beautifully simple:</p>
          <p>Make practice fun. Always.</p>
          <p>We imagine a world where students feel excited (not anxious) when they sit for a practice exam. A world where solving a math test feels like discovering clues in a puzzle. A world where educational fun games support academic mastery without overwhelming them.</p>
          <p>By prioritizing practical skill-building, personalized learning paths, and interactive tools, we aim to help students excel in school and beyond. We want learning to feel like an adventure, powered by curiosity, confidence, and joy.</p>
          <p>Practido isn't just another platform. It's a movement to revolutionize how students learn, revise, and grow. With our blend of structured practice and playful engagement, we're redefining what learning looks like in the modern world- one fun practice exam at a time.</p>                                        
          <a type='btn' rel="noopener noreferrer" className='btn blue-btn' href="https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice" target="_blank">Make Learning Fun - Start Now</a>
        </div>
      </section>

      <section className="faq-main-section faq-container">
        <div className="faq-data">
          <div className="container">
            <h3>Frequently Asked Questions</h3>       
            <div className="update-faq">
              <AboutAccordionPage></AboutAccordionPage>
            </div>
          </div>
        </div>
      </section>
      <ContactForm contactFormRef={setFormRef} />
    </>
  );
};

export default AboutPage;
